// VECTOR: several inputs handed as one array of streams
export const enum TaskIO {
  ATOM = "a",
  STREAM = "s",
  VECTOR = "v",
}

// where a task runs: NORMAL and CACHED cross the wire (only CACHED responses
// stored), INLINE (the planner's operations) in the thread that called it
export const enum TaskExec {
  NORMAL = "n",
  CACHED = "c",
  INLINE = "i",
}

// `exec` is the encoder's: TaskMapEncoder emits its entry's "exec" (default
// cached). The planner only carries it. `props` is false for a task whose props are an empty record: its plan
// call takes the inputs alone.
export type TaskDescriptor = Record<
  string,
  {
    input: TaskIO
    output: TaskIO
    exec: TaskExec
    props: boolean
  }
>
